<template>
  <section v-if="items.length" class="excursion-schedule">
    <h2 class="excursion-schedule__title">{{ t('schedule.title') }}</h2>

    <ul class="excursion-schedule__list">
      <li v-for="item in items" :key="item.id" class="excursion-schedule__item">
        <span class="excursion-schedule__meta">{{ formatMeta(item) }}</span>
        <AppLink class="excursion-schedule__link" :to="item.url">
          {{ item.title }}
        </AppLink>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@experience/i18n';

import { formatDate } from '@/shared/utils/time';

import ru from '../i18n/ru.json';

import type { AttractionScheduleItem } from '../models/attractionCard';

defineProps<{
  items: AttractionScheduleItem[];
}>();

const { t } = useI18n<{ message: typeof ru }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

// date-fns отдаёт сокращённые месяцы с точкой («1 авг., 12:22»), в макете точки нет
const formatStartsAt = (startsAt: Date | string) => formatDate(startsAt, 'd MMM, HH:mm').replace('.,', ',');

const formatMeta = ({ startsAt, priceText }: AttractionScheduleItem) =>
  [startsAt && formatStartsAt(startsAt), priceText].filter(Boolean).join(' · ');
</script>

<style scoped lang="scss">
.excursion-schedule__title {
  margin: 0;

  @include typography.base-700-700-semi;

  @include tablet {
    @include typography.base-600-500-semi;
  }

  @include mobile {
    @include typography.base-500-400-semi;
  }
}

.excursion-schedule__list {
  display: grid;
  gap: 24px;
  padding: 0;
  margin: 24px 0 0;
  list-style: none;

  @include tablet {
    gap: 16px;
    margin: 16px 0 0;
  }
}

.excursion-schedule__item {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: baseline;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  @include typography.base-500-400-regular;

  @include mobile {
    flex-direction: column-reverse;
    align-items: flex-start;

    @include typography.base-400-300-regular;
  }
}

.excursion-schedule__meta {
  color: var(--alias-color-text-default);
  white-space: nowrap;
}

.excursion-schedule__link {
  color: var(--alias-color-text-default);
  text-decoration: underline;
  text-decoration-color: var(--alias-color-link-underline, rgb(0 0 0 / 20%));
  text-underline-offset: 3px;

  &:hover {
    color: var(--alias-color-link-default);
  }
}
</style>
